import React from 'react';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import { Calendar } from "react-modern-calendar-datepicker";
import moment from "jalali-moment";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import TextField from "@material-ui/core/TextField/TextField";
import Button from "@material-ui/core/Button/Button";
import Grid from "@material-ui/core/Grid/Grid";
import {Translate} from "../../../config/Translate";
import {MenuItem} from "@material-ui/core";
import Typography from "@material-ui/core/Typography/Typography";
import TodayRoundedIcon from '@material-ui/icons/TodayRounded';
import IconButton from "@material-ui/core/IconButton/IconButton";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";

const minimumDate = {
    year: parseInt(moment().add(1,'days').locale('fa').format("YYYY")),
    month: parseInt(moment().add(1,'days').locale('fa').format("M")),
    day: parseInt(moment().add(1,'days').locale('fa').format("D")),
};
class FullTimeChooserModal extends React.Component {
    classes = this.props.classes;
    constructor(props){
        let persian_date = minimumDate.year+"/"+minimumDate.month+"/"+minimumDate.day;
        let georgian_date = moment.from(persian_date, 'fa', 'YYYY/M/D').locale('en')
            .format('YYYY-M-D');
        super(props);
        this.state = {
            date:null,
            open:false,
            input:this.props.input,
            hour:19,
            minute:30,
            persian_date,
            georgian_date
        }

    }
    async componentDidMount() {
        let {input} = this.props;
        if(!!input){
            let year =parseInt(moment(input).locale('fa').format("YYYY"));
            let month = parseInt(moment(input).locale('fa').format("M"));
            let day = parseInt(moment(input).locale('fa').format("D"));
            let hour = parseInt(moment(input).locale('fa').format("H"));
            let minute = parseInt(moment(input).locale('fa').format("mm"));
            let date = {
                year,month,day
            }
            await this.setState({
                date,
                hour,
                minute,
            })
            date = date.year+"/"+date.month+"/"+date.day;
            await this.setState({
                persian_date:date
            })
            date = moment.from(date, 'fa', 'YYYY/M/D').locale('en')
                .format('YYYY-M-D');
            await this.setState({
                georgian_date:date
            })
            await this.sendDate();
        }
    }

    async handleDate(date) {
        await this.setState({
            date
        })
        date = date.year+"/"+date.month+"/"+date.day;
        await this.setState({
            persian_date:date
        })
        date = moment.from(date, 'fa', 'YYYY/M/D').locale('en')
            .format('YYYY-M-D');
        await this.setState({
            georgian_date:date
        })
        await this.sendDate();
    }
    sendDate(){
        let {georgian_date,hour,minute} = this.state;
        this.props.handleDate(georgian_date+" "+hour+":"+minute)
    }
    handleClose = () => {
        this.setState({
            open:false
        })
    }
    toggleModal = () => {
        this.setState({
            open:!this.state.open,
        })
    }
    async handleChangeClock(type,val){
        if(type === "minute"){
            await this.setState({
                minute:val
            })
        }else{
            await this.setState({
                hour:val
            })
        }
        await this.sendDate();
    }
    render() {
        let {persian_date,date,open,result,minute,hour} = this.state;
        let {label} = this.props;
        return (
            <div style={{display:"flex",alignItems:"center"}}>
                <Typography style={{marginLeft:15}}>{label}:</Typography>
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => this.toggleModal()}
                    startIcon={<TodayRoundedIcon/>}
                >
                    <span dir="ltr">{persian_date} {hour}:{minute}</span>
                </Button>
                <Dialog
                    open={open}
                    onClose={() => this.handleClose()}
                    maxWidth="xs"
                    className="fulltime-modal"
                    >
                    <DialogTitle>
                        {Translate.chooseDate}
                        <IconButton
                            onClick={() => this.handleClose()}
                            style={{position:"absolute",left:15,top:15}}
                            size="small"
                        >
                            <CloseRoundedIcon fontSize="small"/>
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2} justifyContent="center" alignItems="center">
                            <Grid item xs={12} style={{display:"flex",justifyContent:"center"}}>
                                <Calendar
                                    value={date}
                                    minimumDate={minimumDate}
                                    onChange={this.handleDate.bind(this)}
                                    shouldHighlightWeekends
                                    locale={"fa"}
                                />
                            </Grid>
                            <Grid item xs={5} style={{position: "relative", top: -40, zIndex: 9999999999999999}}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    label={Translate.chooseMinute}
                                    select
                                    value={this.state.minute}
                                    onChange={(e) => this.handleChangeClock('minute',e.target.value)}
                                >
                                    <MenuItem value={0}>00</MenuItem>
                                    <MenuItem value={5}>05</MenuItem>
                                    <MenuItem value={10}>10</MenuItem>
                                    <MenuItem value={15}>15</MenuItem>
                                    <MenuItem value={20}>20</MenuItem>
                                    <MenuItem value={25}>25</MenuItem>
                                    <MenuItem value={30}>30</MenuItem>
                                    <MenuItem value={35}>35</MenuItem>
                                    <MenuItem value={40}>40</MenuItem>
                                    <MenuItem value={45}>45</MenuItem>
                                    <MenuItem value={50}>50</MenuItem>
                                    <MenuItem value={55}>55</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={2} style={{position: "relative", top: -40, zIndex: 9999999999999999,textAlign:"center"}}>
                                :
                            </Grid>
                            <Grid item xs={5} style={{position: "relative", top: -40, zIndex: 9999999999999999}}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    label={Translate.chooseHour}
                                    select
                                    value={this.state.hour}
                                    onChange={(e) => this.handleChangeClock('hour',e.target.value)}

                                >
                                    <MenuItem value={0}>00</MenuItem>
                                    <MenuItem value={1}>01</MenuItem>
                                    <MenuItem value={2}>02</MenuItem>
                                    <MenuItem value={3}>03</MenuItem>
                                    <MenuItem value={4}>04</MenuItem>
                                    <MenuItem value={5}>05</MenuItem>
                                    <MenuItem value={6}>06</MenuItem>
                                    <MenuItem value={7}>07</MenuItem>
                                    <MenuItem value={8}>08</MenuItem>
                                    <MenuItem value={9}>09</MenuItem>
                                    <MenuItem value={10}>10</MenuItem>
                                    <MenuItem value={11}>11</MenuItem>
                                    <MenuItem value={12}>12</MenuItem>
                                    <MenuItem value={13}>13</MenuItem>
                                    <MenuItem value={14}>14</MenuItem>
                                    <MenuItem value={15}>15</MenuItem>
                                    <MenuItem value={16}>16</MenuItem>
                                    <MenuItem value={17}>17</MenuItem>
                                    <MenuItem value={18}>18</MenuItem>
                                    <MenuItem value={19}>19</MenuItem>
                                    <MenuItem value={20}>20</MenuItem>
                                    <MenuItem value={21}>21</MenuItem>
                                    <MenuItem value={22}>22</MenuItem>
                                    <MenuItem value={23}>23</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} style={{marginBottom:10}}>
                                <Button
                                    color="primary"
                                    variant="contained"
                                    onClick={() => this.handleClose()}
                                >
                                    {Translate.selectDate}
                                </Button>
                            </Grid>
                        </Grid>
                    </DialogContent>
                </Dialog>

            </div>
        );
    }
}

export default FullTimeChooserModal;